<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

// 根组件
const route = useRoute();
</script>

<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" v-if="route.meta.keepAlive" />
    </keep-alive>
    <component :is="Component" v-if="!route.meta.keepAlive" />
  </router-view>
</template>

<style scoped>
/* 全局样式在styles/index.scss中定义 */
</style>
